"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StandardSwitch = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _react = _interopRequireWildcard(require("react"));
var _switch = require("./switch.style");
var _ErrorMessage = _interopRequireDefault(require("../ErrorMessage"));
var _Hint = _interopRequireDefault(require("../Hint"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const StandardSwitch = exports.StandardSwitch = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
      className = 'standard-switch',
      id,
      checked = false,
      disabled = false,
      required = false,
      label,
      error,
      hint,
      value,
      fit = 'medium',
      orientation = 'horizontal',
      showOptional,
      width
    } = props,
    restProps = __rest(props, ["className", "id", "checked", "disabled", "required", "label", "error", "hint", "value", "fit", "orientation", "showOptional", "width"]);
  return (0, _jsxRuntime.jsxs)(_switch.Components.Wrapper, (0, _extends2["default"])({
    disabled: disabled,
    width: width,
    className: className
  }, {
    children: [(0, _jsxRuntime.jsx)(_react["default"].Fragment, {
      children: (0, _jsxRuntime.jsxs)(_switch.Components.Label, (0, _extends2["default"])({
        htmlFor: id,
        fit: fit,
        orientation: orientation,
        checked: checked,
        disabled: disabled,
        className: disabled ? 'disabled' : '',
        tabIndex: 0
      }, {
        children: [(0, _jsxRuntime.jsx)(_switch.Components.Input, (0, _extends2["default"])({
          id: id,
          checked: checked,
          value: value,
          disabled: disabled,
          ref: ref
        }, restProps)), label, showOptional && !required && (0, _jsxRuntime.jsx)("span", (0, _extends2["default"])({
          className: "optional"
        }, {
          children: " (optional)"
        })), !showOptional && required && (0, _jsxRuntime.jsx)("span", {
          className: "required"
        })]
      }))
    }), error && (0, _jsxRuntime.jsx)(_ErrorMessage["default"], (0, _extends2["default"])({
      fit: fit
    }, restProps)), hint && (0, _jsxRuntime.jsx)(_Hint["default"], {
      hint: hint,
      fit: fit
    })]
  }));
});
var _default = exports["default"] = StandardSwitch;